import type { DateGroup } from '@/utils/helpers/group-periods-by-same-date';

const isSameTimePattern = (a: DateGroup, b: DateGroup): boolean => {
  if (a.timeRanges.length !== b.timeRanges.length) {
    return false;
  }

  return a.timeRanges.every((range, i) => range.timeRange === b.timeRanges[i].timeRange);
};

const isConsecutiveDay = (a: DateGroup, b: DateGroup): boolean => {
  const aDate = new Date(a.dateObj.getFullYear(), a.dateObj.getMonth(), a.dateObj.getDate());
  const bDate = new Date(b.dateObj.getFullYear(), b.dateObj.getMonth(), b.dateObj.getDate());
  const diffDays = (bDate.getTime() - aDate.getTime()) / (1000 * 60 * 60 * 24);

  return diffDays === 1;
};

const canGroupTogether = (a: DateGroup, b: DateGroup): boolean =>
  isSameTimePattern(a, b) && isConsecutiveDay(a, b);

export const groupPeriodsByConsecutiveDays = (dateGroups: DateGroup[]): DateGroup[][] => {
  const groups: DateGroup[][] = [];
  let currentGroup: DateGroup[] = [dateGroups[0]];

  for (let i = 1; i < dateGroups.length; i++) {
    const prev = dateGroups[i - 1];
    const curr = dateGroups[i];

    if (canGroupTogether(prev, curr)) {
      currentGroup.push(curr);
    } else {
      groups.push(currentGroup);
      currentGroup = [curr];
    }
  }

  groups.push(currentGroup);

  return groups;
};
